import { Permission } from '../constants';

export interface MenuItemModel {
  title: string;
  url?: string;
  icon?: string;
  permission?: Permission | string;
  children?: MenuItemModel[];
  externalUrl?: string;
}
